import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import HelpComp from '../../../components/patientApp/patientChat/help/help';

const Help = () => {
    return <Background>
        <HelpComp />
    </Background>
}
export default Help;